import {searchBadging} from '../../utils/constants/signalmanConstants';

export const searchBadgingTest = () => {
  return CustomInk.Metrics.fireEvent(
    'testing',
    ' 2024 06 03 search badging',
    ` 2024 06 03 search badging ${searchBadging}`
  );
};
